interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPrevPage: () => void;
  onNextPage: () => void;
}

export function Pagination({
  currentPage,
  totalPages,
  onPrevPage,
  onNextPage,
}: PaginationProps) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex justify-center items-center gap-4 mt-4">
      <button
        type="button"
        onClick={onPrevPage}
        disabled={currentPage === 0}
        className="px-3 py-1.5 text-sm font-medium rounded border border-gray-200 bg-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
      >
        Anterior
      </button>
      <span className="text-sm text-mid-gray">
        Página {currentPage + 1} de {totalPages}
      </span>
      <button
        type="button"
        onClick={onNextPage}
        disabled={currentPage === totalPages - 1}
        className="px-3 py-1.5 text-sm font-medium rounded border border-gray-200 bg-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
      >
        Siguiente
      </button>
    </div>
  );
}
